import React from "react";
import { useTranslation } from "react-i18next";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="fixed bottom-[120px] right-[55px] z-50 h5:right-[32px]"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
      <img src={require("../assets/image/icon22.png")} className="w-[30px] cursor-pointer" alt="" />
    </div>
  );
};

export default ComponentName;
